// utils/authUtils.js
// Common JWT authentication utilities

// Get JWT headers for API calls
export const getAuthHeaders = () => {
  const token = localStorage.getItem('jwtToken');
  const tokenType = localStorage.getItem('tokenType') || 'Bearer';
  
  const headers = {
    'Content-Type': 'application/json',
  };
  
  if (token) {
    headers.Authorization = `${tokenType} ${token}`;
  }
  
  return headers;
};

// Handle authentication errors
export const handleAuthError = (response) => {
  if (response.status === 401) {
    // Token expired or invalid - clear auth data and redirect
    clearAuthData();
    
    // Redirect to login
    const basePath = process.env.REACT_APP_BASE_URL || '';
    window.location.href = `${basePath}/login`;
    throw new Error('Authentication failed - redirecting to login');
  }
};

// Clear all authentication data
export const clearAuthData = () => {
  localStorage.removeItem('jwtToken');
  localStorage.removeItem('tokenType');
  localStorage.removeItem('userId');
  localStorage.removeItem('username');
  localStorage.removeItem('tokenExpiration');
  localStorage.removeItem('userPreferences');
  localStorage.removeItem('userSettings');
};

// Check if user is authenticated
export const isAuthenticated = () => {
  const token = localStorage.getItem('jwtToken');
  const expiration = localStorage.getItem('tokenExpiration');
  
  if (!token) return false;
  if (!expiration) return true; // No expiration set, assume valid
  
  return new Date().getTime() < parseInt(expiration);
};

// Get current user info from localStorage
export const getCurrentUser = () => {
  return {
    id: localStorage.getItem('userId'),
    username: localStorage.getItem('username'),
    token: localStorage.getItem('jwtToken'),
  };
};

// Generic authenticated fetch wrapper
export const authenticatedFetch = async (url, options = {}) => {
  // Check if token is expired before making request
  if (!isAuthenticated()) {
    clearAuthData();
    const basePath = process.env.REACT_APP_BASE_URL || '';
    window.location.href = `${basePath}/login`;
    throw new Error('Token expired');
  }

  const config = {
    ...options,
    headers: {
      ...getAuthHeaders(),
      ...options.headers,
    },
  };

  try {
    const response = await fetch(url, config);
    
    // Handle authentication errors
    handleAuthError(response);

    return response;
  } catch (error) {
    console.error('Authenticated fetch failed:', error);
    throw error;
  }
};

// Store JWT token and user info after login
export const storeAuthData = (userData) => {
  if (userData.jwtToken) {
    localStorage.setItem('jwtToken', userData.jwtToken);
    localStorage.setItem('tokenType', userData.tokenType || 'Bearer');
    localStorage.setItem('userId', userData.id);
    localStorage.setItem('role', userData.role);
    localStorage.setItem('username', userData.username);
    localStorage.setItem('activeSubscription', userData.activeSubscription ? 'true' : 'false');
    
    // Set expiration (24 hours from now)
    const expirationTime = new Date().getTime() + (24 * 60 * 60 * 1000);
    localStorage.setItem('tokenExpiration', expirationTime);
    
    console.log('JWT Token stored successfully');
  }
};